import { render, staticRenderFns } from "./file-loader.vue?vue&type=template&id=274a680c&scoped=true"
import script from "./file-loader.vue?vue&type=script&lang=js"
export * from "./file-loader.vue?vue&type=script&lang=js"
import style0 from "./file-loader.vue?vue&type=style&index=0&id=274a680c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274a680c",
  null
  
)

export default component.exports